import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const DocketEntryTypeNotificationsState = {
  docketEntryTypeNotifications: [],
}

export const DocketEntryTypeNotificationsActions = {
  getDocketEntryTypeNotifications: async ({ commit }) => {
    return axiosRequest.
      get('/docket_entry_types/notifications').
      then(({ data }) => commit('setDocketEntryTypeNotifications', data)).
      catch(handleError)
  },

  createDocketEntryTypeNotification: async ({ commit }, notification) => {
    return axiosRequest.
      post('/docket_entry_types/notifications', { docket_entry_type_notification: notification }).
      then(({ data }) => commit('setDocketEntryTypeNotification', data)).
      catch(handleError)
  },

  updateDocketEntryTypeNotification: async ({ commit }, notification) => {
    return axiosRequest.
      patch(`/docket_entry_types/notifications/${notification.id}`, { docket_entry_type_notification: notification }).
      then(({ data }) => commit('setDocketEntryTypeNotification', data)).
      catch(handleError)
  },

  deleteDocketEntryTypeNotification: async ({ commit }, notificationId) => {
    return axiosRequest.
      delete(`/docket_entry_types/notifications/${notificationId}`).
      then(({ data }) => commit('removeDocketEntryTypeNotification', data)).
      catch(handleError)
  },
}

export const DocketEntryTypeNotificationsMutations = {
  setDocketEntryTypeNotifications: (state, payload) => { state.docketEntryTypeNotifications = payload },

  setDocketEntryTypeNotification: (state, payload) => {
    const idx = state.docketEntryTypeNotifications.findIndex(t => t.id === payload.id)

    if (idx < 0) state.docketEntryTypeNotifications.push(payload)
    else Vue.set(state.docketEntryTypeNotifications, idx, payload)
  },

  removeDocketEntryTypeNotification: (state, payload) => {
    const idx = state.docketEntryTypeNotifications.findIndex(t => t.id === payload.id)
    if (idx < 0) return

    state.docketEntryTypeNotifications.splice(idx, 1)
  },
}

export const DocketEntryTypeNotificationsGetters = {
  docketEntryTypeNotifications: state => state.docketEntryTypeNotifications,
}
